
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    size: {
      type: Number as PropType<number>,
      required: true,
      validator: (value: number) => {
        return value > 0 && value <= 12
      }
    }
  }
})
